export const kommunay = () => {
    return(
        <div>
            <div className="content" readonly=""><h1>Кейс внедрения комплексной системы учета для нефтедобывающей
                компании «Ком-Мунай»</h1>

                <h2>Заказчик</h2>
                <p><strong>Компания ТОО «Ком-Мунай»</strong> — крупное предприятие в нефтегазовом секторе Казахстана,
                    занимающееся разведкой и добычей углеводородного сырья.</p>

                <h2>Задача</h2>
                <p>После смены собственника и выхода иностранного инвестора с рынка перед предприятием встала задача
                    перехода с SAP на 1С. Основные требования:</p>
                <ul>
                    <li>Объединить учетные процессы в единую информационную систему.</li>
                    <li>Автоматизировать бухгалтерский учет, налоговый учет, управление кадрами, закупки, склад, ТОиР.
                    </li>
                    <li>Интеграция с внешними сервисами и модулями управления документацией.</li>
                    <li>Минимизация рисков и бесперебойный переход на новую систему без потери данных.</li>
                </ul>

                <h2>Решение</h2>
                <p>Внедрение было выполнено Группой компаний «Кибернетика» на базе 1С:Предприятие с использованием
                    специализированных отраслевых решений для нефтегазовой отрасли.</p>
                <ul>
                    <li> Перенос данных из предыдущих систем автоматизации.</li>
                    <li> Настройка бухгалтерского и налогового учета, включая автоматический расчет налогов, рентных
                        платежей и себестоимости добычи.
                    </li>
                    <li> Автоматизация кадрового учета и расчетов зарплаты с учетом вахтового метода, социальных и
                        отпускных выплат.
                    </li>
                    <li> Внедрение модуля ТОиР (техническое обслуживание и ремонты) для планирования и контроля
                        эксплуатационных работ.
                    </li>
                    <li> Интеграция с 1С:Документооборот для управления договорами и внутренним документооборотом.</li>
                    <li> Автоматизация закупок и складского учета, включая управление запасами и распределение ресурсов
                        по месторождениям.
                    </li>
                    <li> Настройка финансового планирования (бюджетирование, казначейство, управление затратами).</li>
                </ul>

                <h2>Результаты</h2>
                <ul>
                    <li> Внедренная система позволила централизовать управление всеми бизнес-процессами.</li>
                    <li> Учетная система работает на 136 автоматизированных рабочих местах, обеспечивая полную
                        прозрачность операций.
                    </li>
                    <li> Сокращены временные затраты на расчет зарплат, налогов и учет себестоимости.</li>
                    <li> Упрощено формирование отчетности для внутренних нужд и регуляторов.</li>
                    <li> Обеспечена интеграция с другими корпоративными сервисами и учетными системами.</li>
                    <li> Отзыв заказчика — высший балл за удобство работы, соответствие потребностям бизнеса и качество
                        внедрения.
                    </li>
                </ul>
            </div>
        </div>
    )
}